/** Business Config shared constants (reorderable client-side list paging). */

export const BUSINESS_CONFIG_PER_PAGE_OPTIONS: readonly number[] = [15, 30, 50, 100]

export const BUSINESS_CONFIG_DEFAULT_PER_PAGE = 15
